import { getId } from "helpers/functions";
import {
  DELETE_DEVELOPER_REQUEST,
  DELETE_DEVELOPER_REQUEST_FAILURE,
  DELETE_DEVELOPER_REQUEST_SUCCESS,
  GET_DEVELOPER_REQUESTS,
  GET_DEVELOPER_REQUESTS_FAILURE,
  GET_DEVELOPER_REQUESTS_SUCCESS,
  GET_SINGLE_DEVELOPER_REQUEST,
  GET_SINGLE_DEVELOPER_REQUEST_FAILURE,
  GET_SINGLE_DEVELOPER_REQUEST_SUCCESS,
} from "./actionTypes";

const initialState = {
  developerRequests: [],
  loading: false,
  error: "",
  singleDeveloperRequest: {},
};

const developerRequests = (state = initialState, action) => {
  switch (action.type) {
    case GET_DEVELOPER_REQUESTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_DEVELOPER_REQUESTS_SUCCESS:
      state = {
        ...state,
        loading: false,
        developerRequests: action.payload.developersRequests,
      };
      break;
    case GET_DEVELOPER_REQUESTS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_DEVELOPER_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_SINGLE_DEVELOPER_REQUEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleDeveloperRequest: action.payload.developer,
      };
      break;

    case GET_SINGLE_DEVELOPER_REQUEST_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
        singleDeveloperRequest: {},
      };
      break;

    case DELETE_DEVELOPER_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_DEVELOPER_REQUEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        developerRequests: state.developerRequests.filter(
          (req) => getId(req) !== action.payload?.id
        ),
      };
      break;
    case DELETE_DEVELOPER_REQUEST_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default developerRequests;
